import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M15 6.833v13.334c0 1.11 2 1.11 2 0V6.833c0-1.11-2-1.11-2 0M14.7 24.5a1.3 1.3 0 1 0 2.6 0 1.3 1.3 0 0 0-2.6 0",
      clipRule: "evenodd"
    }
  )
);
var SvgWarningMarkOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var WarningMarkOutlined_default = SvgWarningMarkOutlined;

export { WarningMarkOutlined_default as default };
